import { useMemo } from 'react';
import { raporBul } from '../../utils/raporSonek';
import type { PanelScreen, ParameterConfig, ReportConfig } from '../../types/panelConfig';

/** Bir sorgu kaynagi: ds id'si + bildirdigi parametreler (parametre gonderme karari buradan). */
export interface SaKaynak {
  sourceId: number;
  name: string;
  parameters: ParameterConfig[];
}

/** SQL 139'un firma 7 `satis-analiz` config'ine yazdigi anahtarlar (Task B3). */
export type EkranKaynakAnahtari =
  | 'kategori' | 'gunlukKar' | 'enCokSatan' | 'zararinaSatis' | 'iadeOrani' | 'urunKarliligi';

export interface SatisKaynaklari {
  kanal040?: SaKaynak;
  saatlik002?: SaKaynak;
  isi042?: SaKaynak;
  sepet019?: SaKaynak;
  cokSatan014?: SaKaynak;
  kritik025?: SaKaynak;
  kategori?: SaKaynak;
  gunlukKar?: SaKaynak;
  enCokSatan?: SaKaynak;
  zararinaSatis?: SaKaynak;
  iadeOrani?: SaKaynak;
  urunKarliligi?: SaKaynak;
}

const EKRAN_ANAHTARLARI: EkranKaynakAnahtari[] = [
  'kategori', 'gunlukKar', 'enCokSatan', 'zararinaSatis', 'iadeOrani', 'urunKarliligi',
];

/**
 * Menude KALAN ds. `beklenenAd` ZORUNLU: sonek carpismasinda (051-070 firma 7'de pasif ittihat
 * sablonlariyla dolu; 035'te baska firmada "Acik Hesaplar") blok yanlis veri basmak yerine gizlenir.
 */
export function menuKaynagi(reports: ReportConfig[], sonek: number, beklenenAd: string): SaKaynak | undefined {
  const r = raporBul(reports, sonek, beklenenAd);
  if (!r || r.sourceId === null || r.sourceId === undefined) return undefined;
  return { sourceId: r.sourceId, name: r.name, parameters: r.parameters ?? [] };
}

/** Ekrana ozel (menude gizli) ds: `reports`ta YOKTUR, yalniz ekran `kaynaklar` sozlugunden gelir. */
export function ekranKaynagi(screen: PanelScreen, anahtar: EkranKaynakAnahtari): SaKaynak | undefined {
  const k = screen.kaynaklar?.[anahtar];
  if (!k || typeof k.sourceId !== 'number') return undefined;
  return { sourceId: k.sourceId, name: k.name, parameters: k.parameters ?? [] };
}

export function satisKaynaklari(screen: PanelScreen, reports: ReportConfig[]): SatisKaynaklari {
  const sonuc: SatisKaynaklari = {
    kanal040: menuKaynagi(reports, 40, 'Satış Kanalı Özeti'),
    saatlik002: menuKaynagi(reports, 2, 'Saatlik Satış Dağılımı'),
    isi042: menuKaynagi(reports, 42, 'Saat × Gün Dağılımı'),
    sepet019: menuKaynagi(reports, 19, 'Birlikte Satılan Ürünler (son 90 gün)'),
    cokSatan014: menuKaynagi(reports, 14, 'En Çok Satan Ürünler'),
    kritik025: menuKaynagi(reports, 25, 'Kritik Stok'),
  };
  for (const a of EKRAN_ANAHTARLARI) sonuc[a] = ekranKaynagi(screen, a);
  return sonuc;
}

export function useSatisKaynaklari(screen: PanelScreen, reports: ReportConfig[]): SatisKaynaklari {
  return useMemo(() => satisKaynaklari(screen, reports), [screen, reports]);
}
